export default __webpack_public_path__ + "bbcab185265f8f61662276caaebaff40.svg";